import { render } from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=template&id=9b29d018&scoped=true"
import script from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=style&index=0&id=9b29d018&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b29d018"]])

export default __exports__